<template>
	<div>
		<div class="modal-background" @click="$emit('close')">
			<div class="modal-container shadowed" @click.prevent.stop="">
				<div class="modal-title">
					{{ title }}
					<button class="modal-close" @click="$emit('close')" :disabled="loading">
						<i class="fa fa-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: "ModalRouting",

		props: [ "loading", "title", "on_save" ],

		data: function() {
			return {
				
			};
		},

		methods: {

		},

		computed: {
			has_save_listener: function() {
				return this.$listeners && this.$listeners.save;
			},
		},

	}
</script>


<style scoped>

.modal-background {
	width: 100vw;
	height: 100vh;
	position: fixed;
	top:0;
	left:0;
	background: #222222cc;
	z-index: 9;
}

.modal-container {
	width: calc(100vw - 60px);
	height: calc(100vh - 60px);
	margin: 30px auto;
	background: #fff;
	border-radius: 4px;
	border: 1px solid #ddd;
}

.modal-title {
	position: relative;
	border-bottom: 1px solid #ddd;
	height: 50px;
	line-height: 50px;
	padding: 0 15px 0 15px;
	font-weight: bold;
	background: #f9f9f9;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	width: 100%;
	height: calc(100vh - 112px);
	overflow-y: auto;
	overflow-x: hidden;
}

.modal-footer {
	width: 100%;
	height: 70px;
	border-top: 1px solid #ddd;
	background: #f9f9f9;
}




.modal-button-close {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	line-height: 25px;
	margin-left: 15px;
	margin-top: 15px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	margin-right: 15px;
	margin-top: 15px;
	font-size: 12px;
	font-weight: bold;
}

</style>